/**
 * PDPCatalog.tsx — Shopify BOPIS product page behaviors.
 */
(function () {
  'use strict';

  var root = document.getElementById('ez-pdp-catalog');
  if (!root) return;

  document.body.classList.add('ez-pdp-catalog-sticky-active');

  var initialStore = root.dataset.initialStoreName;
  var baseSavedCount = parseInt(root.dataset.savedCount || '0', 10) || 0;

  var modal = document.getElementById('ez-pdp-interest-modal');
  var confirmModal = document.getElementById('ez-pdp-interest-confirm-modal');
  var interestButtons = root.querySelectorAll('[data-ez-pdp-interest-open]');
  var variantSelect = root.querySelector('[data-ez-pdp-variant-select]');
  var addToCartButtons = root.querySelectorAll('[data-ez-pdp-add-to-cart]');
  var closeBtn = modal && modal.querySelector('[data-ez-pdp-interest-close]');
  var confirmCloseBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-interest-confirm-close]');
  var confirmDoneBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-interest-confirm-done]');
  var wishlistButtons = root.querySelectorAll('[data-ez-pdp-wishlist]');
  var storeLabel = root.querySelector('[data-ez-pdp-store-label]');
  var saveCountEls = root.querySelectorAll('[data-ez-pdp-save-count]');
  var savedBadge = root.querySelector('[data-ez-pdp-saved-badge]');
  var form = document.getElementById('ez-pdp-interest-form');
  // var bodyField = form && form.querySelector('[data-ez-pdp-interest-body]');
  // var contactNameField = form && form.querySelector('[data-ez-pdp-contact-name]');
  var nameInput = form && form.querySelector('[data-ez-pdp-name]');
  var mobileInput = form && form.querySelector('[data-ez-pdp-mobile]');
  var noteInput = form && form.querySelector('[data-ez-pdp-note]');
  var consentCheckbox = form && form.querySelector('[data-ez-pdp-consent]');
  var submitBtn = form && form.querySelector('[data-ez-pdp-interest-submit]');
  var interestStoreNameEls = document.querySelectorAll('[data-ez-pdp-interest-store-name-text]');
  var confirmStoreName = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-store-name]');
  var confirmHoursBadge = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-hours-badge]');
  var confirmPhoneRow = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-phone-row]');
  var confirmContactPhone = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-phone]');
  var confirmContactPhoneText = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-phone-text]');
  var confirmCallBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-call-btn]');
  var confirmContactAddress = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-address]');
  var confirmContactAddressText = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-address-text]');
  var confirmDirections = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-directions]');
  var confirmMap = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-map]');
  var confirmMapIframe = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-map-iframe]');

  var galleryTrack = root.querySelector('[data-ez-pdp-gallery-track]');
  var galleryCounter = root.querySelector('[data-ez-pdp-gallery-counter]');
  var galleryDots = root.querySelector('[data-ez-pdp-gallery-dots]');
  var thumbButtons = root.querySelectorAll('[data-ez-pdp-thumb]');

  var storeNameEl = root.querySelector('[data-ez-pdp-store-name]');
  var storeAddressEl = root.querySelector('[data-ez-pdp-store-address]');
  var storePhoneEl = root.querySelector('[data-ez-pdp-store-phone]');
  var storeDirectionsEl = root.querySelector('[data-ez-pdp-store-directions]');
  var storeHoursEl = root.querySelector('[data-ez-pdp-store-hours]');
  var storeMapEl = root.querySelector('[data-ez-pdp-store-map]');
  var storeMapIframe = root.querySelector('[data-ez-pdp-store-map-iframe]');

  function getSwymButton() {
    return document.querySelector(
      '.swym-add-to-wishlist-view-product.product_' + root.dataset.productId
    );
  }

  function getDisplaySavedCount(userSaved) {
    return baseSavedCount + (userSaved ? 1 : 0);
  }

  function updateSaveCounts(userSaved) {
    var count = getDisplaySavedCount(userSaved);
    var show = count >= 1;
    saveCountEls.forEach(function (el) {
      if (show) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    if (savedBadge && count > 0) {
      savedBadge.textContent = 'Saved by ' + count + ' people';
      savedBadge.hidden = false;
    }
  }

  function syncWishlistPressed() {
    var swym = getSwymButton();
    var saved = swym && (swym.classList.contains('swym-added') || swym.getAttribute('aria-pressed') === 'true');
    wishlistButtons.forEach(function (btn) {
      btn.classList.toggle('is-saved', !!saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from Wishlist' : 'Save to Wishlist');
    });
    updateSaveCounts(!!saved);
  }

  function getStoreHoursLabel(store) {
    if (!store || !store.hours) return '';
    var today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
    var hoursToday = store.hours[today] ? store.hours[today] : '';
    if (!hoursToday || hoursToday === 'Closed' || hoursToday === 'Closed today') {
      return 'Closed today';
    }
    var closingParts = hoursToday.split(/[–-]/);
    var closingTime = closingParts.length > 1 ? closingParts[closingParts.length - 1].trim() : hoursToday;
    return 'Open until ' + closingTime;
  }

  // stores.js / Shopify store pages only store the street; city/state come from product tags
  // (city_*, state_*) or the store name tail (e.g. "… Laredo TX").
  function titleCaseWords(value) {
    return String(value || '')
      .trim()
      .replace(/\b([a-z])/g, function (_, c) {
        return c.toUpperCase();
      });
  }

  function cityStateFromName(name) {
    var nameTail = (name || '').indexOf(' - ') !== -1 ? (name || '').split(' - ').pop() : name;
    nameTail = String(nameTail || '').trim();
    if (!nameTail) return { city: '', state: '' };

    var commaMatch = nameTail.match(/,\s*([A-Za-z .'-]+),\s*([A-Z]{2})\b/);
    if (commaMatch) {
      return { city: commaMatch[1].trim(), state: commaMatch[2] };
    }

    // Drop street line ("1102 Zaragoza St.") so trailing "Laredo TX" remains.
    var locTail = nameTail.replace(
      /^.*?\b(?:St|Street|Ave|Avenue|Blvd|Rd|Road|Dr|Drive|Hwy|Highway|Ln|Lane|Pkwy|Plaza|Way|Ct|Court|Pike|Fwy|Freeway)\.?\s+/i,
      ''
    );
    var spaceMatch = locTail.match(/^([A-Za-z][A-Za-z .'-]*?)\s+([A-Z]{2})\s*$/);
    if (spaceMatch) {
      return { city: spaceMatch[1].trim(), state: spaceMatch[2] };
    }

    spaceMatch = nameTail.match(/\b([A-Za-z][A-Za-z']*)\s+([A-Z]{2})\s*$/);
    if (spaceMatch) {
      return { city: spaceMatch[1].trim(), state: spaceMatch[2] };
    }

    return { city: '', state: '' };
  }

  function formatStoreAddress(store) {
    if (!store) return '';
    var street = String(store.address || '').trim();
    var city = titleCaseWords(root.dataset.storeCity || '');
    var state = titleCaseWords(root.dataset.storeState || '');

    if (city) {
      var cityRe = new RegExp('^' + city.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+(?=\\d)', 'i');
      street = street.replace(cityRe, '').trim() || street;
    } else {
      street = street.replace(/^([A-Za-z .'-]+)\s+(?=\d)/, '').trim() || street;
    }

    if (!city || !state) {
      var parsed = cityStateFromName(store.name);
      city = city || parsed.city;
      state = state || parsed.state;
    }

    var parts = [street];
    if (city && state) {
      parts.push(city + ', ' + state);
    } else if (city) {
      parts.push(city);
    }
    return parts.filter(Boolean).join(', ');
  }

  function splitFullName(fullName) {
    var parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: '' };
    return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
  }

  function updateInterestStoreNames(name) {
    interestStoreNameEls.forEach(function (el) {
      el.textContent = name;
    });
    if (confirmStoreName) confirmStoreName.textContent = name;
  }

  function updateConfirmModalContent() {
    var store = (window.storesData || {})[window.currentStoreTag];
    if (confirmPhoneRow) confirmPhoneRow.hidden = true;
    if (confirmContactAddress) confirmContactAddress.hidden = true;
    if (confirmMap) confirmMap.hidden = true;
    if (confirmDirections) confirmDirections.hidden = true;
    if (confirmHoursBadge) confirmHoursBadge.hidden = true;
    if (!store) return;
    var name = store.brand || store.name || 'Store';

    updateInterestStoreNames(name);

    if (confirmHoursBadge) {
      var hoursLabel = getStoreHoursLabel(store);
      if (hoursLabel) {
        confirmHoursBadge.textContent = hoursLabel;
        confirmHoursBadge.hidden = false;
      }
    }

    if (confirmContactPhone && confirmContactPhoneText && store.phone) {
      // var telHref = 'tel:' + store.phone.replace(/\D/g, '');
      confirmContactPhoneText.textContent = store.phone;
      // confirmContactPhone.href = telHref;
      // if (confirmCallBtn) confirmCallBtn.href = telHref;
      confirmContactPhone.href = phoneHref('sms', store.phone);
      confirmContactPhone.setAttribute('aria-label', 'Text store at ' + store.phone);
      if (confirmCallBtn) {
        confirmCallBtn.href = phoneHref('tel', store.phone);
        confirmCallBtn.setAttribute('aria-label', 'Call store at ' + store.phone);
      }
      if (confirmPhoneRow) confirmPhoneRow.hidden = false;
    }

    var fullAddress = formatStoreAddress(store);
    if (confirmContactAddress && confirmContactAddressText && fullAddress) {
      confirmContactAddressText.textContent = fullAddress;
      confirmContactAddress.hidden = false;
    }

    if (confirmDirections && fullAddress) {
      confirmDirections.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress);
      confirmDirections.hidden = false;
    }

    if (confirmMap && confirmMapIframe && store.map_embed_url) {
      confirmMapIframe.src = store.map_embed_url;
      confirmMap.hidden = false;
    } else if (confirmMap) {
      confirmMap.hidden = true;
      if (confirmMapIframe) confirmMapIframe.removeAttribute('src');
    }
  }

  function updateStoreLabels() {
    var store = (window.storesData || {})[window.currentStoreTag];
    if (!store) return;
    var name = store.brand || store.name || 'Store';
    var text = name + ' · text or call back';
    if (storeLabel) storeLabel.textContent = text;
    if (storeNameEl) storeNameEl.textContent = name;
    updateInterestStoreNames(name);

    var fullAddress = formatStoreAddress(store);
    if (storeAddressEl) storeAddressEl.textContent = fullAddress;
    if (storeHoursEl) {
      var today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
      var hoursToday = store.hours && store.hours[today] ? store.hours[today] : 'See store hours';
      if (hoursToday === 'Closed' || hoursToday === 'Closed today') {
        storeHoursEl.textContent = '● Closed today';
      } else {
        var closingParts = hoursToday.split(/[–-]/);
        var closingTime =
          closingParts.length > 1 ? closingParts[closingParts.length - 1].trim() : hoursToday;
        storeHoursEl.textContent = '● Open until ' + closingTime;
      }
    }
    if (storePhoneEl && store.phone) {
      storePhoneEl.textContent = store.phone;
      storePhoneEl.href = phoneHref('sms', store.phone);
      storePhoneEl.setAttribute('aria-label', 'Text store at ' + store.phone);
      storePhoneEl.hidden = false;
    }
    if (storeDirectionsEl && fullAddress) {
      storeDirectionsEl.href =
        'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress);
      storeDirectionsEl.hidden = false;
    }

    if (storeMapIframe && store.map_embed_url) {
      if (storeMapIframe.src !== store.map_embed_url) {
        storeMapIframe.src = store.map_embed_url;
      }
      if (storeMapEl) storeMapEl.hidden = false;
    } else if (storeMapEl) {
      storeMapEl.hidden = true;
      if (storeMapIframe) storeMapIframe.removeAttribute('src');
    }

    updateConfirmModalContent();
  }

  function initDescriptionTabs() {
    var tabs = root.querySelectorAll('[data-ez-pdp-desc-tab]');
    var panels = root.querySelectorAll('[data-ez-pdp-desc-panel]');
    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      var target = tab.getAttribute('data-ez-pdp-desc-tab');

      for (var i = 0; i < tabs.length; i++) {
        var isActive = tabs[i] === tab;
        tabs[i].classList.toggle('is-active', isActive);
        tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabs[i].tabIndex = isActive ? 0 : -1;
      }

      for (var j = 0; j < panels.length; j++) {
        var isActive = panels[j].getAttribute('data-ez-pdp-desc-panel') === target;
        panels[j].classList.toggle('is-active', isActive);
        if (isActive) {
          panels[j].removeAttribute('hidden');
        } else {
          panels[j].setAttribute('hidden', '');
        }
      }
    }

    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        activateTab(this);
      });
    }

    var tablist = root.querySelector('.ez-pdp-catalog__desc-tabs[role="tablist"]');
    if (!tablist) return;

    tablist.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;

      var currentIndex = -1;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i] === document.activeElement) {
          currentIndex = i;
          break;
        }
      }
      if (currentIndex === -1) currentIndex = 0;

      var nextIndex = currentIndex;
      if (key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      else if (key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      else if (key === 'Home') nextIndex = 0;
      else if (key === 'End') nextIndex = tabs.length - 1;

      event.preventDefault();
      tabs[nextIndex].focus();
      activateTab(tabs[nextIndex]);
    });
  }

  function openModal() {
    if (!modal) return;
    validateForm();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (nameInput) nameInput.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!confirmModal || !confirmModal.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  var confirmCloseGuardUntil = 0;
  function openConfirmModal() {
    if (!confirmModal) return;
    confirmCloseGuardUntil = Date.now() + 300;
    updateConfirmModalContent();
    confirmModal.classList.add('is-open');
    confirmModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
    if (confirmDoneBtn) confirmDoneBtn.focus();
      if (confirmDoneBtn && confirmModal.classList.contains('is-open')) confirmDoneBtn.focus();
    }, 50);
  }

  function closeConfirmModal(opts) {
    if (!confirmModal) return;
    if (opts && opts.guardClicks && Date.now() < confirmCloseGuardUntil) return;
    confirmModal.classList.remove('is-open');
    confirmModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (confirmMapIframe) confirmMapIframe.removeAttribute('src');
    if (confirmMap) confirmMap.hidden = true;
  }

  function getExponea() {
    return window.exponea;
  }

  function formatPhoneE164(digits) {
    if (!digits) return '';
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return '+' + digits;
  }

  function phoneHref(scheme, phone) {
    var e164 = formatPhoneE164(String(phone || '').replace(/\D/g, ''));
    return e164 ? scheme + ':' + e164 : '#';
  }

  function getInterestFormValues() {
    var emailInput = form && form.querySelector('#ez-pdp-email');
    var fullName = nameInput ? nameInput.value.trim() : '';
    var nameParts = splitFullName(fullName);
    var email = emailInput ? emailInput.value.trim() : '';
    var phoneDigits = mobileInput ? mobileInput.value.replace(/\D/g, '') : '';
    var note = noteInput ? noteInput.value.trim() : '';
    var hasConsent = consentCheckbox ? consentCheckbox.checked : false;
    var hasEmail = email.length > 0;
    var hasPhone = phoneDigits.length >= 10;
    return {
      fullName: fullName,
      firstName: nameParts.firstName,
      lastName: nameParts.lastName,
      email: email,
      phone: mobileInput ? mobileInput.value.trim() : '',
      phoneE164: formatPhoneE164(phoneDigits),
      note: note,
      hasConsent: hasConsent,
      hasEmail: hasEmail,
      hasPhone: hasPhone,
      emailMarketing: hasEmail && hasConsent,
      smsMarketing: hasPhone && hasConsent,
    };
  }

  function trackConsentEvent(exponea, action, category, values) {
    var props = {
      action: action,
      category: category,
      valid_until: 'unlimited',
      timestamp: new Date().toISOString(),
      source: 'store_inquiry_form',
    };
    if (values.email) props.email = values.email;
    if (values.phoneE164 && category.indexOf('sms') === 0) props.phone = values.phoneE164;
    exponea.track('consent', props);
  }

  function trackInterestExponea() {
    var exponea = getExponea();
    if (!exponea || typeof exponea.track !== 'function') return;

    var values = getInterestFormValues();
    var displayedStore = getDisplayedStoreInfo() || {};

    if (typeof exponea.identify === 'function' && (values.email || values.phoneE164)) {
      var ids = {};
      if (values.email) ids.email_id = values.email;
      if (values.phoneE164) ids.phone_id = values.phoneE164;
      exponea.identify(ids);
    }

    if (typeof exponea.update === 'function') {
      var updatePayload = {
        first_name: values.firstName,
        last_name: values.lastName,
      };
      if (values.email) updatePayload.email = values.email;
      if (values.phoneE164) updatePayload.phone = values.phoneE164;
      exponea.update(updatePayload);
    }

    exponea.track('store_inquiry', {
      product_id: root.dataset.productId || '',
      product_title: root.dataset.productTitle || '',
      product_handle: root.dataset.productHandle || '',
      variant_id: root.dataset.variantId || '',
      product_url: window.location.href,
      first_name: values.firstName,
      last_name: values.lastName,
      full_name: values.fullName,
      email: values.email,
      phone: values.phone,
      note: values.note,
      consent_given: values.hasConsent,
      email_marketing: values.emailMarketing,
      sms_marketing: values.smsMarketing,
      store_name: displayedStore.store_name || '',
      store_phone: displayedStore.store_phone || '',
      store_address: displayedStore.store_address || '',
      store_hours: displayedStore.store_hours || '',
      store_distance: displayedStore.store_distance || '',
      consent_timestamp: values.hasConsent ? new Date().toISOString() : null,
      timestamp: new Date().toISOString()
    });

    trackConsentEvent(
      exponea,
      values.emailMarketing ? 'accept' : 'reject',
      'email-marketing',
      values
    );
    trackConsentEvent(exponea, values.smsMarketing ? 'accept' : 'reject', 'sms-ezplus', values);
  }

  function validateForm() {
    if (!submitBtn || !nameInput || !mobileInput) return;
    var nameOk = nameInput.value.trim().length > 0;
    var digits = mobileInput.value.replace(/\D/g, '');
    var mobileOk = digits.length >= 10;
    var consentOk = consentCheckbox ? consentCheckbox.checked : false;
    submitBtn.disabled = !(nameOk && mobileOk && consentOk);
  }

  function getDisplayedStoreInfo() {
    var card = root.querySelector('[data-ez-pdp-store-card]');
    if (!card) return null;

    function text(el) {
      return el && !el.hidden ? el.textContent.trim() : '';
    }

    var info = {
      store_name: (card.querySelector('[data-ez-pdp-store-name]') || {}).textContent || '',
      store_address: (card.querySelector('[data-ez-pdp-store-address]') || {}).textContent || '',
      store_phone: text(card.querySelector('[data-ez-pdp-store-phone]')),
      store_hours: (card.querySelector('[data-ez-pdp-store-hours]') || {}).textContent || '',
      store_distance: text(card.querySelector('[data-ez-pdp-store-distance]')),
    };
    info.store_name = info.store_name.trim();
    info.store_address = info.store_address.trim();
    info.store_hours = info.store_hours.trim();

    if (!info.store_name && !info.store_address && !info.store_phone) return null;
    return info;
  }

  function bodyOverflows(body) {
    if (!body) return false;
    var wasExpanded = body.classList.contains('is-expanded');
    body.classList.remove('is-expanded');
    var overflows = body.scrollHeight > body.clientHeight + 1;
    if (wasExpanded) body.classList.add('is-expanded');
    return overflows;
  }

  function updateReadMoreVisibility(wrap) {
    var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
    var btn = wrap.querySelector('[data-ez-pdp-read-more]');
    if (!body || !btn) return;

    var expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      btn.hidden = false;
      return;
    }

    btn.hidden = !bodyOverflows(body);
  }

  function initReadMoreLinks() {
    var wraps = root.querySelectorAll('[data-ez-pdp-read-more-wrap]');

    function refreshAll() {
      wraps.forEach(updateReadMoreVisibility);
    }

    wraps.forEach(function (wrap) {
      var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
      var btn = wrap.querySelector('[data-ez-pdp-read-more]');
      if (!body || !btn) return;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var nextExpanded = !expanded;

        btn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        body.classList.toggle('is-expanded', nextExpanded);
        btn.textContent = nextExpanded ? 'Read less' : 'Read more';
        btn.hidden = false;
      });
    });

    refreshAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshAll, 150);
    });
  }

  function initGallery() {
    if (!galleryTrack) return;
    var slides = galleryTrack.querySelectorAll('[data-ez-pdp-gallery-slide]');
    var total = slides.length;
    if (total <= 1) return;

    if (galleryDots) {
      galleryDots.innerHTML = '';
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('span');
        dot.className = 'ez-pdp-catalog__gallery-dot' + (d === 0 ? ' is-active' : '');
        galleryDots.appendChild(dot);
      }
    }

    var currentIndex = 0;
    var prevArrow = root.querySelector('[data-ez-pdp-gallery-prev]');
    var nextArrow = root.querySelector('[data-ez-pdp-gallery-next]');
    var progressBar = root.querySelector('[data-ez-pdp-gallery-progress]');

    if (progressBar) progressBar.style.width = 100 / total + '%';

    function setActive(index) {
      currentIndex = index;
      if (galleryCounter) galleryCounter.textContent = index + 1 + ' / ' + total;
      if (galleryDots) {
        var dots = galleryDots.querySelectorAll('.ez-pdp-catalog__gallery-dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      if (progressBar) progressBar.style.transform = 'translateX(' + index * 100 + '%)';
      thumbButtons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
      if (prevArrow) prevArrow.disabled = index <= 0;
      if (nextArrow) nextArrow.disabled = index >= total - 1;
    }

    function scrollToIndex(index) {
      var w = galleryTrack.offsetWidth;
      if (!w) return;
      galleryTrack.scrollTo({ left: index * w, behavior: 'smooth' });
      setActive(index);
    }

    galleryTrack.addEventListener(
      'scroll',
      function () {
        var w = galleryTrack.offsetWidth;
        if (!w) return;
        setActive(Math.round(galleryTrack.scrollLeft / w));
      },
      { passive: true }
    );

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollToIndex(parseInt(btn.getAttribute('data-ez-pdp-thumb') || '0', 10));
      });
    });
    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        if (currentIndex > 0) scrollToIndex(currentIndex - 1);
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        if (currentIndex < total - 1) scrollToIndex(currentIndex + 1);
      });
    }

    setActive(0);
  }

  /* Drift hover zoom — desktop / fine pointer only (parity with Warehouse ProductGallery._createZoom) */
  function initImageZoom() {
    if (root.dataset.enableImageZoom !== 'true') return;
    if (typeof Drift === 'undefined') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var zoomWrapper = root.querySelector('.ez-pdp-catalog__zoom-wrapper');
    var zoomEffect = root.dataset.zoomEffect || 'outside';
    var images = root.querySelectorAll('.ez-pdp-catalog__gallery-img[data-zoom]');
    if (!images.length) return;

    var stackedLayout = window.matchMedia('(max-width: 767px)').matches;
    images.forEach(function (image) {
      new Drift(image, {
        containInline: zoomEffect === 'outside',
        inlinePane: stackedLayout ? true : zoomEffect !== 'outside',
        hoverBoundingBox: zoomEffect === 'outside',
        handleTouch: false,
        inlineOffsetY: stackedLayout ? -85 : 0,
        paneContainer: zoomWrapper,
      });
    });
  }

  function atcAddLabel() {
    return (window.languages && window.languages.productFormAddToCart) || 'Add to cart';
  }

  function atcAddedLabel() {
    return (window.languages && window.languages.productFormAddedToCart) || 'Added to the cart';
  }

  function atcAddingLabel() {
    return (window.languages && window.languages.productFormAdding) || 'Adding...';
  }

  var cartVariantIds = Object.create(null);

  function setCartVariantIds(ids) {
    cartVariantIds = Object.create(null);
    (ids || []).forEach(function (id) {
      if (id) cartVariantIds[String(id)] = true;
    });
  }

  function currentVariantId() {
    if (variantSelect && variantSelect.value) return String(variantSelect.value);
    return String(root.dataset.variantId || '');
  }

  function syncAddToCartLabel() {
    if (!addToCartButtons.length) return;
    var adding = atcAddingLabel();
    var label = cartVariantIds[currentVariantId()] ? atcAddedLabel() : atcAddLabel();
    addToCartButtons.forEach(function (btn) {
      if (btn.textContent === adding) return;
      btn.textContent = label;
      btn.setAttribute('data-original-text', label);
    });
  }

  function refreshCartVariantIds() {
    var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
    fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        setCartVariantIds(
          cart.items.map(function (item) {
            return item.variant_id;
          })
        );
        syncAddToCartLabel();
      })
      .catch(function () {});
  }

  function updateAddToCartAvailability() {
    if (!variantSelect || !addToCartButtons.length) return;
    var option = variantSelect.options[variantSelect.selectedIndex];
    var available = option && !option.disabled;
    addToCartButtons.forEach(function (btn) {
      btn.disabled = !available;
      btn.classList.toggle('ez-pdp-catalog__btn-primary--disabled', !available);
    });
    if (root.dataset.variantId && option) {
      root.dataset.variantId = option.value;
    }
    syncAddToCartLabel();
  }

  if (root.dataset.isOnlineExclusive === 'true' && addToCartButtons.length) {
    setCartVariantIds((root.dataset.cartVariantIds || '').split(','));
    syncAddToCartLabel();

    document.addEventListener('product:added', function (event) {
      var variant = event.detail && event.detail.variant;
      var id = variant && variant.id;
      if (id) cartVariantIds[String(id)] = true;
      else if (currentVariantId()) cartVariantIds[currentVariantId()] = true;
      syncAddToCartLabel();
    });

    document.addEventListener('cart:rerendered', refreshCartVariantIds, true);
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', updateAddToCartAvailability);
    updateAddToCartAvailability();
  }
  
  interestButtons.forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });
  if (storeMapEl && storeDirectionsEl) {
    storeMapEl.addEventListener('click', function () {
      if (storeDirectionsEl.hidden) return;
      var href = storeDirectionsEl.getAttribute('href');
      if (!href || href === '#') return;
      storeDirectionsEl.click();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  
  if (confirmCloseBtn) {
    confirmCloseBtn.addEventListener('click', function () {
      closeConfirmModal({ guardClicks: true });
    });
  }
  if (confirmDoneBtn) {
    confirmDoneBtn.addEventListener('click', function () {
      closeConfirmModal({ guardClicks: true });
    });
  }
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }
  if (confirmModal) {
    confirmModal.addEventListener('click', function (e) {
      if (e.target === confirmModal) closeConfirmModal({ guardClicks: true });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (confirmModal && confirmModal.classList.contains('is-open')) {
      closeConfirmModal();
      return;
    }
    if (modal && modal.classList.contains('is-open')) closeModal();
  });

  wishlistButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var swym = getSwymButton();
      if (swym) swym.click();
      setTimeout(syncWishlistPressed, 400);
    });
  });

  function handleInterestSubmit(e) {
    if (e) {
      e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
    }
      
      validateForm();
      if (submitBtn && submitBtn.disabled) return;

      trackInterestExponea();

      form.reset();
      if (consentCheckbox) consentCheckbox.checked = true;
      if (submitBtn) {
      submitBtn.textContent = 'Submit';
      submitBtn.disabled = true;
      }
    // Open confirm first (with click guard) so a WebKit ghost-click hits the
    // guarded overlay, not the page under the closing interest modal.
    openConfirmModal();
    closeModal();
  }

  if (form) {
    form.addEventListener('input', validateForm);
    form.addEventListener('change', validateForm);
    // Belt-and-suspenders: cancel any native submit (e.g. Enter in an input).
    form.addEventListener('submit', handleInterestSubmit);
    if (submitBtn) submitBtn.addEventListener('click', handleInterestSubmit);
    validateForm();
  }

  if (initialStore) {
    var text = initialStore + ' · text or call back';
    if (storeLabel) storeLabel.textContent = text;
    updateInterestStoreNames(initialStore);
  }

  document.addEventListener('storesDataReady', function () {
    updateStoreLabels();
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (window.storesData) updateStoreLabels();
  });
  if (window.storesData) updateStoreLabels();

  function initPickupTabletPlacement() {
    var block = root.querySelector('[data-ez-pdp-pickup-block]');
    var home = root.querySelector('[data-ez-pdp-pickup-home]');
    var gallery = root.querySelector('.ez-pdp-catalog__gallery');
    if (!block || !home || !gallery) return;

    var mq = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');

    function place() {
      if (mq.matches) {
        if (block.previousElementSibling !== gallery) {
          gallery.insertAdjacentElement('afterend', block);
        }
      } else if (block.parentElement !== home) {
        home.appendChild(block);
      }
    }

    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);
  }

  initReadMoreLinks();
  initGallery();
  initImageZoom();
  initDescriptionTabs();
  initPickupTabletPlacement();
  syncWishlistPressed();

  var swymObserve = getSwymButton();
  if (swymObserve && typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(syncWishlistPressed);
    mo.observe(swymObserve, { attributes: true, attributeFilter: ['class', 'aria-pressed'] });
  }

  setInterval(syncWishlistPressed, 2000);
})();
